"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var owa_junkmail_configuration_1 = require("owa-junkmail-configuration");
var owa_mail_option_common_1 = require("owa-mail-option-common");
var legacy_1 = require("satcheljs/lib/legacy");
var arrayEquals = require('array-equal');
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    mailboxJunkEmailConfiguration: function () { return owa_junkmail_configuration_1.getMailboxJunkEmailConfiguration(); },
})(function isBlockedSendersOptionDirty(state) {
    var _a = state, optionState = _a.optionState, mailboxJunkEmailConfiguration = _a.mailboxJunkEmailConfiguration;
    if (!mailboxJunkEmailConfiguration || !optionState.blockedSenders) {
        return false;
    }
    return !arrayEquals(optionState.blockedSenders, mailboxJunkEmailConfiguration.BlockedSendersAndDomains.filter(function (item) { return owa_mail_option_common_1.isEmailAddress(item); }));
});
//# sourceMappingURL=isBlockedSendersOptionDirty.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-blocked-senders-option/lib/utils/isBlockedSendersOptionDirty.js
// module id = 5038
// module chunks = 2